var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 168,
    viewBox: "0 0 325 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fru0z4wkga"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8996",
    width: 325,
    height: 168,
    rx: 20,
    transform: "translate(25 132)",
    style: {
      fill: "#d8cfff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao2udm858b"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8975",
    width: 244.935,
    height: 61.619,
    rx: 30.809,
    transform: "rotate(180 122.468 30.81)",
    style: {
      opacity: 0.45,
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "saf71nxvzc"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8950",
    width: 244.935,
    height: 48.765,
    rx: 24.382,
    transform: "rotate(180 122.468 24.383)",
    style: {
      opacity: 0.45,
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -132)",
    style: {
      clipPath: "url(#fru0z4wkga)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8986",
    width: 325,
    height: 168,
    rx: 20,
    transform: "translate(25 132)",
    style: {
      fill: "#d8cfff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9322",
    transform: "translate(27.429 134.807)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 983",
    transform: "rotate(-40 300.412 73.407)",
    style: {
      clipPath: "url(#ao2udm858b)",
      opacity: 0.38
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1578"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8964",
    transform: "translate(-.77)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8965",
    transform: "translate(-.77 24.648)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8966",
    transform: "translate(-.77 61.619)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8967",
    transform: "translate(-.77 12.324)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8968",
    transform: "translate(-.77 49.295)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8969",
    transform: "translate(-.77 36.971)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8970",
    transform: "translate(-.77 6.162)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8971",
    transform: "translate(-.77 30.809)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8972",
    transform: "translate(-.77 18.486)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8973",
    transform: "translate(-.77 55.457)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8974",
    transform: "translate(-.77 43.133)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v2.311H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 982",
    transform: "rotate(-40 31.933 -8.754)",
    style: {
      clipPath: "url(#saf71nxvzc)",
      opacity: 0.38
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1577"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8936",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z",
    transform: "translate(-.77)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8957",
    transform: "translate(-.77 19.506)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8961",
    transform: "translate(-.77 48.765)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8953",
    transform: "translate(-.77 9.753)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8963",
    transform: "translate(-.77 39.012)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8955",
    transform: "translate(-.77 29.259)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8951",
    transform: "translate(-.77 4.876)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8956",
    transform: "translate(-.77 24.382)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8952",
    transform: "translate(-.77 14.629)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8962",
    transform: "translate(-.77 43.888)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8954",
    transform: "translate(-.77 34.135)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h247.246v1.829H0z"
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8935",
    width: 244.935,
    height: 14.619,
    rx: 7.309,
    transform: "rotate(-40 279.404 285.018)",
    style: {
      opacity: 0.3,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8901",
    width: 244.935,
    height: 61.619,
    rx: 30.809,
    transform: "rotate(-40 248.197 -299.12)",
    style: {
      opacity: 0.3,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 8900",
    width: 244.935,
    height: 61.619,
    rx: 30.809,
    transform: "rotate(-40 286.658 -609.629)",
    style: {
      opacity: 0.45,
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointBg);
export default __webpack_public_path__ + "static/media/point_bg.eabceb5fed8228917ab478c3db6a6256.svg";
export { ForwardRef as ReactComponent };